/* global AFRAME, THREE */

AFRAME.registerComponent('closebutton', {
  init: function () {
    var self = this;
    var sceneEl = this.el;

    var closeEl = this.createCloseButton(this.buttonClick);

    sceneEl.appendChild(closeEl);
  },

  createCloseButton: function (onClick) {
    var button = document.getElementById('button-close');

    button.addEventListener('click', function (evt) {
      onClick();
      evt.stopPropagation();
    });

    return button;
  },

  buttonClick: function () {
    var hamburger = document.getElementById('button-menu');
    var videoEl = document.getElementById(hamburger.VideoId);

    var player = new Vimeo.Player(videoEl);
    player.pause();

    player.removeCuePoint(hamburger.cueId).then(function(id) {
      //
    }).catch(function(error) {
      switch (error.name) {
          default:
              // some other error occurred
              //console.log('okay. I got it. no probs!');
              break;
      }
    });

    player.unload().then(function() {
      //console.log('buttonClick: the video was unloaded: cueId ' + hamburger.cueId);
      player.off('play');
      player.off('cuepoint');
    });

    // Fire end event
    var evt = new Event('ended');
    hamburger.dispatchEvent(evt);
  },
});
